import React, { SelectHTMLAttributes } from 'react'
import styled from '@emotion/styled'
import { space, SpaceProps } from 'styled-system'

const Select: React.FC<SelectHTMLAttributes<void> & SpaceProps> = styled('select')`
  display: block;
  width: 100%;
  appearance: none;
  color: #363636;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  height: 49px;
  padding: 10px 16px;

  font-size: 16px;
  font-weight: 300;
  line-height: 1.33;
  border-radius: 15px;
  margin: 1px;
  &::placeholder {
    color: #999;
  }
  &:focus {
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  }
  ${space}
`

export default Select
